import { api } from "../api";


export async function inspectTeamInvite(token) {
  return (await api.post("/api/team/invitations/inspect", { token })).data;
}

export async function redeemTeamInvite(payload) {
  return (await api.post("/api/team/invitations/redeem", payload)).data;
}

export async function getTeam() {
  return (await api.get("/api/secure/team")).data;
}

export async function inviteTeamMember(payload) {
  return (await api.post("/api/secure/team/invitations", payload)).data;
}

export async function resendTeamInvite(invitationId) {
  return (await api.post(`/api/secure/team/invitations/${invitationId}/resend`)).data;
}

export async function revokeTeamInvite(invitationId) {
  return (await api.post(`/api/secure/team/invitations/${invitationId}/revoke`)).data;
}

export async function updateTeamUserStatus(userId, status) {
  return (await api.patch(`/api/secure/team/users/${userId}/status`, { status })).data;
}

export async function updateTeamUserRole(userId, role) {
  return (await api.patch(`/api/secure/team/users/${userId}/role`, { role })).data;
}
